import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CartStore} from '../../../core/stores/cart.store';
import {CartItem} from '../../../core/models/cart-item.model';
import {PopoverController} from '@ionic/angular';
import {RouteService} from '../../../core/services/route.service';
import {OrderApiService} from '../../../core/services/order.api.service';
import {PaymentStore} from '../../../core/stores/payment.store';
import {Country, Restaurant} from '../../../core/models/restaurant.model';
import {RestaurantStore} from '../../../core/stores/restaurant.store';
import {FormatStyleService} from '../../../core/services/format-style.service';
import {LoyaltyBannerType} from '../../../core/models/payment-item.model';
import { URL } from '../../../core/enums/url.enum';
import { ItemService } from '../../../core/services/item.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  @Input() isGroup: boolean;
  @Input() restaurant: Restaurant;
  @Input() restaurantsInGroup: Restaurant[];
  menuItemsInCart: CartItem[];

  constructor(public cartStore: CartStore,
              private paymentStore: PaymentStore,
              private restaurantStore: RestaurantStore,
              private orderApiService: OrderApiService,
              private formatStyleService: FormatStyleService,
              private popoverController: PopoverController,
              private router: Router,
              private itemService: ItemService,
              private routeService: RouteService) {
  }

  ngOnInit() {
    this.cartStore.items$.subscribe(
      () => {
        this.menuItemsInCart = this.cartStore.cartItems;
      },
      error => console.error(error)
    );
  }

  public get showLoyaltyBanner(): boolean {
    return this.isLoyaltyEnabled && !!this.cartStore.loyalty && this.cartStore.loyalty.pointsValue > 0 && this.menuItemsInCart.length > 0;
  }

  public get loyaltyBannerType(): LoyaltyBannerType {
    return LoyaltyBannerType.CART;
  }

  public get isLoyaltyEnabled(): boolean {
    return !this.isGroup && this.cartStore.isLoyaltyEnabled;
  }

  public get cartButtonText(): string {
    if (this.cartStore.updateCartInProgress) {
      return 'Cart updating...';
    } else {
      return 'Checkout';
    }
  }

  public getFormattedPrice(price: string | number, quantity = 1): string {
    return (+price * quantity).toFixed(2);
  }

  public deleteItemFromCart(i: number) {
    this.cartStore.updateCartInProgress = true;
    if (this.isGroup) {
      const merchantUrl = `merchants/${this.restaurantsInGroup.find((restaurant) => restaurant.locationId === this.cartStore.items[i].locationId).merchantId}`;
      this.orderApiService.deleteItemFromOrderMap(i, merchantUrl);
    } else {
      this.orderApiService.deleteItemFromOrderMap(i);
    }
  }

  public close() {
    this.popoverController.dismiss();
  }

  public goToCheckoutPage(): void {
    if (this.cartStore.items.length > 0) {
      if (this.isGroup) {
        if (this.cartStore.countOrderMapRestaurants === 1 && !this.cartStore.groupTab) {
          const restaurant = this.restaurantStore.findLocationById(this.restaurantsInGroup, Object.keys(this.cartStore.orderMap)[0]);
          this.restaurantStore.isGroup = false;
          this.getRestaurantAndOpenInCheckout(restaurant);
        } else {
          const groupUrl = this.routeService.getGroupUrl();
          this.close();
          this.router.navigate([groupUrl, 'checkout']).catch(error => console.error(error));
        }
      } else {
        const locationUrl = this.routeService.getLocationUrl();
        this.close();
        (this.itemService.checkMerchantId() || this.itemService.checkLocationId(this.restaurant.locationId)) && !this.itemService.checkServiceItem() ?
          this.router.navigate([locationUrl, 'checkout', URL.service_items]).catch(error => console.error(error)) :
          this.router.navigate([locationUrl, 'checkout']).catch(error => console.error(error));
      }
    }
  }

  private getRestaurantAndOpenInCheckout(restaurant: Restaurant): void {
    if (restaurant) {
      this.cartStore.kyooFee = restaurant.kyooFee;
      this.cartStore.autoGratuityPercent = restaurant.autoGratuityPercent;
      this.cartStore.driverGratuityPercent = restaurant.defaultDeliveryAutoGratuityPercent;
      this.cartStore.enableRestaurantTips = restaurant.enableRestaurantTip;
      this.cartStore.tippingEnabled = restaurant.isTippingEnabled;
      this.restaurantStore.hideRestaurantOrdersAhead = restaurant.hideOrdersAhead;
      this.restaurantStore.disableTodayOrders = restaurant.disableTodayOrders;
      this.restaurantStore.timezone = restaurant.timezone;
      this.restaurantStore.restaurantCountryInfo = Country.getCountryByName(restaurant.country);
      this.formatStyleService.setGlobalBrandColor(restaurant.brandColor);
      this.formatStyleService.setGlobalBackgroundColor(restaurant.backgroundColor);
      this.formatStyleService.setGlobalBorderColor(restaurant.borderColor);
      this.formatStyleService.setGlobalPrimaryTextColor(restaurant.primaryTextColor);
      this.formatStyleService.setGlobalSecondaryTextColor(restaurant.secondaryTextColor);
      if (restaurant.availableStatus) {
        this.restaurantStore.setRestaurantAvailableStatus(restaurant.availableStatus);
        this.restaurantStore.setRestaurantIsAvailable(true);
      } else {
        this.restaurantStore.setRestaurantIsAvailable(false);
      }
      this.restaurantStore.getRestaurantFulfillment(restaurant, this.restaurantStore.fulfillmentParams);
      const url = this.routeService.createLocationUrl(restaurant.merchantId, restaurant.locationId);
      this.close();
      this.router.navigate([url, 'checkout']).catch(error => console.error(error));
    }
  }
}
